module.exports = "/_next/static/images/find-bg-mobile-5871749b88188f10463a7891b129f311.svg";